import firebase from 'firebase/app';
import 'firebase/auth';

/*const firebaseConfig = {
	apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
	authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
	databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
	projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
	storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
	messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID,
	appId: process.env.VUE_APP_FIREBASE_APPID,
};*/

const firebase_app = firebase.initializeApp(window.firebaseConfig);

// To apply the default browser preference instead of explicitly setting it.
// firebase.auth().useDeviceLanguage();
firebase_app.languageCode = 'en';


export default firebase_app;



const createCaptchaVerifier = function() {
	let config = {
		size: 'invisible',
		badge: 'bottomleft',
		callback: (response) => window.onRecaptchaVerifier(response)
    }
    if (!window.recaptchaVerifier) {
		window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', config);
    }
    return window.recaptchaVerifier;
}
// window.createCaptchaVerifier = createCaptchaVerifier


export const auth = {

	/**
	 * [signUpWithPassword description]
	 * @param  {string} email    
	 * @param  {string} password 
	 * @return {Promise<UserCredential>}
	 */
	signUpWithPassword: function(email, password) {
		return new Promise((resolve, reject) => {
		    firebase_app.auth().createUserWithEmailAndPassword(email, password)
		    	.then(function(result) {
				    return resolve(result.user.toJSON());
		    	})
		        .catch(function(error) {
		        	return reject(error);
		        });
		});
	},


	/**
	 * [signInWithFacebook description]
	 * @return {Promise<UserCredential>}
	 */
	signInWithFacebook: function() {
		let provider = new firebase.auth.FacebookAuthProvider();
		provider.addScope('email');

		return new Promise((resolve, reject) => {
			firebase_app.auth().signInWithPopup(provider)
				.then(function(result) {
					// This gives you a Facebook Access Token. You can use it to access the Facebook API.
		  			// let token = result.credential.accessToken;
		  			// let user = result.user;
		  			return resolve(result.user.toJSON());
				})
				.catch(function(error) {
					return reject(error);
		        });
		});
	},


	/**
	 * [signInWithGoogle description]
	 * @return {Promise<UserCredential>}
	 */
	signInWithGoogle: function() {
		let provider = new firebase.auth.GoogleAuthProvider();
		provider.addScope('https://www.googleapis.com/auth/userinfo.email');
	    provider.addScope('https://www.googleapis.com/auth/userinfo.profile');
	    provider.addScope('email');

	    return new Promise((resolve, reject) => {
			firebase_app.auth().signInWithPopup(provider)
				.then(function(result) {
					// This gives you a Facebook Access Token. You can use it to access the Facebook API.
		  			// let token = result.credential.accessToken;
		  			// let user = result.user;
		  			return resolve(result.user.toJSON());
				})
				.catch(function(error) {
					return reject(error);
		        });
		});
	},


	/**
	 * [signInWithPassword description]
	 * @param  {string} email    
	 * @param  {string} password
	 * @return {Promise<UserCredential>}
	 */
	signInWithPassword: function(email, password) {
		return new Promise((resolve, reject) => {
		    firebase_app.auth().signInWithEmailAndPassword(email, password)
		    	.then(function(result) {
				    return resolve(result.user.toJSON());
		    	})
		        .catch(function(error) {
		        	return reject(error);
		        });
		});
	},


	/**
	 * [signInWithPhoneNumber description]
	 * @param  {string} phone_number 
	 * @return {Promise}
	 */
	signInWithPhoneNumber: function(phone_number) {
		return new Promise((resolve, reject) => {
			firebase_app.auth().signInWithPhoneNumber(phone_number, createCaptchaVerifier())
				.then((confirmationResult) => {
					// SMS sent. Prompt user to type the code from the message, then sign the
					// user in with confirmationResult.confirm(code).
					return resolve(confirmationResult);
				}).catch((error) => {
					return reject(error);
				});
		});
	},


	/**
	 * [confirmSignIn description]
	 * @param  {mixed}  confirmationResult 
	 * @param  {string} code
	 * @return {Promise<UserCredential>}
	 */
	confirmSignIn: function(confirmationResult, code) {
		let credential = firebase.auth.PhoneAuthProvider.credential(confirmationResult.verificationId, code);
		return new Promise((resolve, reject) => {
			firebase_app.auth().signInWithCredential(credential)
				.then(function(result) {
				    return resolve(result.user.toJSON());
		    	})
		        .catch(function(error) {
		        	return reject(error);
		        })
		        .then(() => {
		        	window.grecaptcha.reset();
		        });
		});
	},


	/**
	 * [logout description]
	 * @return {[type]} [description]
	 */
	logout: function() {
		return new Promise((resolve, reject) => {
		firebase_app.auth().signOut()
			.then(function() {
				return resolve(true);
			})
			.catch(function(error) {
			  	return reject(error);
			});
		});
	},



	/**
	 * You can customize the email template that is used in Authentication section 
	 * of the Firebase console, on the Email Templates page. 
	 * See Email Templates in Firebase Help Center.
	 * It is also possible to pass state via a continue URL to redirect back to the app when sending a password reset email.
	 * @param  {string} email 
	 * @return {[type]}       [description]
	 */
	sendPasswordResetEmail: function(email) {
		return new Promise((resolve, reject) => {
			firebase_app.auth().sendPasswordResetEmail(email)
				.then(function(result) {
					return resolve(result);
				}).catch(function(error) {
					return reject(error);
				});
		});
	},


	/**
	 * Sends a verification email to a user.
	 * The verification process is completed by calling firebase.auth.Auth.applyActionCode
	 * @return {Promise}
	 */
	sendEmailVerification: function() {
		let user = firebase_app.auth().currentUser;
		if (!user) return;
		
		let actionCodeSettings = null;

		return new Promise((resolve, reject) => {
			user.sendEmailVerification(actionCodeSettings)
				.then(function(result) {
					return resolve(result);
				}).catch(function(error) {
					return reject(error);
				});
		});
	},


	getCurrentUser: function() {
		return firebase_app.auth().currentUser;
	},

	onAuthStateChanged: function() {
		return firebase_app.auth().onAuthStateChanged(user => user);
	},

	onIdTokenChanged: function(callback) {
		return firebase_app.auth().onIdTokenChanged(user => callback(user))
	}

};